/*
 * Quick View - show the images that belong to the selected colour.
 *
 * Why this is needed:
 * The theme groups product media by colour in Product.setImagePositions(), which tags
 * every media item with data-swatch = the image position of the colour it belongs to.
 * Variants._updateImages() then shows only the media whose data-swatch matches the
 * selected variant's featured image position.
 *
 * Inside the Quick View modal, openModalProduct() calls productSetup() - and therefore
 * setImagePositions() - synchronously, before the fetched product blocks (including the
 * colour swatches it reads the positions from) have been inserted into the modal. No
 * media ever receives data-swatch, so selecting a colour cannot change the image, and a
 * variant change hides every item in the modal's media grid instead.
 *
 * This script re-runs the grouping once the Quick View content is actually in the DOM
 * and re-applies it after every variant change. It is scoped to the Quick View modal;
 * product pages keep using the theme's own logic.
 */
(function () {
  // The snippet that loads this file is output once per product card, so guard against
  // the listeners being registered more than once per page.
  if (window.quickViewColourImagesReady) return;
  window.quickViewColourImagesReady = true;

  var SWATCH_SELECTOR = '.variant__input--color-swatch';
  var GRID_ITEM_SELECTOR = '.main-product__media--grid-item';
  var SLIDER_SELECTORS = ['.swiper--product-gallery', '.swiper--product-thumbs'];

  function readColours(container) {
    var swatches = Array.prototype.slice.call(container.querySelectorAll(SWATCH_SELECTOR));
    if (!swatches.length) return null;

    var positions = swatches
      .map(function (swatch) { return parseInt(swatch.getAttribute('data-position'), 10); })
      .filter(function (position) { return !isNaN(position) && position > 0; })
      .sort(function (a, b) { return a - b; });
    if (!positions.length) return null;

    var checked = swatches.filter(function (swatch) { return swatch.checked; })[0] || swatches[0];
    var active = parseInt(checked.getAttribute('data-position'), 10);
    if (isNaN(active) || active <= 0) active = positions[0];

    return { positions: positions, active: active };
  }

  function groupOf(positions, position) {
    var group = positions[0];
    for (var i = 0; i < positions.length; i++) {
      if (positions[i] <= position) group = positions[i];
    }
    return group;
  }

  // Every piece of media in the modal, paired with its 1-based position in the gallery.
  function mediaItems(container) {
    var items = [];

    container.querySelectorAll(GRID_ITEM_SELECTOR).forEach(function (item) {
      var position = parseInt(item.getAttribute('data-position'), 10);
      if (isNaN(position) || position <= 0) return;
      items.push({ element: item, position: position });
    });

    SLIDER_SELECTORS.forEach(function (selector) {
      var wrapper = container.querySelector(selector);
      if (!wrapper) return;
      // Slides are rendered in media order, so the index is the position.
      Array.prototype.slice.call(wrapper.querySelectorAll('.swiper-slide')).forEach(function (slide, index) {
        items.push({ element: slide, position: index + 1 });
      });
    });

    return items;
  }

  function refreshSliders(container) {
    SLIDER_SELECTORS.forEach(function (selector) {
      var wrapper = container.querySelector(selector);
      if (!wrapper || !wrapper.swiper) return;
      try {
        wrapper.swiper.update();
        wrapper.swiper.slideTo(0, 0);
      } catch (error) {
        /* slider not ready - the slides are already filtered, nothing else to do */
      }
    });
  }

  function applyColourImages(container) {
    if (!container) return;

    var items = mediaItems(container);
    if (!items.length) return;

    var colours = readColours(container);

    if (!colours) {
      // No colour option on this product: every image belongs to it.
      items.forEach(function (item) { item.element.style.display = ''; });
      refreshSliders(container);
      return;
    }

    items.forEach(function (item) {
      var group = groupOf(colours.positions, item.position);
      item.element.setAttribute('data-swatch', group);
      item.element.style.display = group === colours.active ? '' : 'none';
    });

    refreshSliders(container);
  }

  function applyAfterThemeHandlers(container) {
    if (!container) return;
    // Runs after the theme's own variantChange handler so this has the last word.
    window.setTimeout(function () { applyColourImages(container); }, 0);
  }

  function quickViewModal(productId) {
    if (!productId) return null;
    return document.getElementById('QuickShopModal-' + productId);
  }

  document.addEventListener('quickview:loaded', function (event) {
    applyAfterThemeHandlers(quickViewModal(event.detail && event.detail.productId));
  });

  document.addEventListener('quickview:open', function (event) {
    applyAfterThemeHandlers(quickViewModal(event.detail && event.detail.productId));
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.hasAttribute || !target.hasAttribute('data-variant-input')) return;
    applyAfterThemeHandlers(target.closest('.modal--quick-shop'));
  }, true);

  /*
   * The theme's variant handler reads a global `product` object that only the product
   * page defines. On collection, search and every other template the Quick View throws
   * "product is not defined" part way through the variant update. A harmless fallback
   * lets that handler run to completion. The product page sets its own `product` in an
   * inline script that runs before this deferred file, so this never overwrites it.
   */
  if (typeof window.product === 'undefined') {
    window.product = { tags: [] };
  }
})();
